// array functions
Array.prototype.dynamicSort = function(property,orderByAsc) {
    function dynamicSortComparator(property,orderByAsc) {
        var sortOrder = orderByAsc ? 1 : -1;

        return function (a,b) {
            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        }
    }
    
    var sortedArray = this;
    if(property!=null && property != undefined){
       orderByAsc = orderByAsc == null ||  orderByAsc == undefined ? true : orderByAsc; 
       sortedArray =  this.sort(dynamicSortComparator(property,orderByAsc))
    }
	return  sortedArray;
};

Array.prototype.unique = function() {
    var arr = [];
    for(var i = 0; i < this.length; i++) {
        if(!arr.contains(this[i])) {
            arr.push(this[i]);
        }
    }
    return arr; 
};
Array.prototype.contains = function(v) {
    for(var i = 0; i < this.length; i++) {
        if(this[i] === v) return true;
    }
    return false;
};